import { lazy } from 'react';
import Loadable from 'components/Loadable';

const MeetingList = Loadable(lazy(() => import('./components/meeting-list/MeetingList')));

export const meetingRoutes = {
  path: 'meetings',
  children: [
    { index: true, element: <MeetingList /> },
    { path: 'list', element: <MeetingList /> },
    { path: 'room/:roomId', element: <div className="meet-route-placeholder" /> }
  ]
};

export default meetingRoutes;
